/**
 * Keeps UTM parameters and the first-landing referrer for the browser session so lead forms can post them even when
 * the Referer header is stripped or the visitor navigated away from the landing URL. Server side (LeadAttribution)
 * reads these posted fields first.
 */
const KEY = "peakidx_attribution";
const UTM_NAMES = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function readStored(): Record<string, string> {
    try {
        const v = window.sessionStorage.getItem(KEY);
        if (v) return JSON.parse(v);
    } catch (e) {
        // storage unavailable
    }
    return {};
}

export function captureAttribution(): void {
    try {
        const stored = readStored();
        const params = new URLSearchParams(window.location.search);
        let changed = false;
        for (const name of UTM_NAMES) {
            const v = params.get(name);
            if (v && !stored[name]) {
                stored[name] = v.substring(0, 255);
                changed = true;
            }
        }
        if (stored["first_referrer"] === undefined) {
            stored["first_referrer"] = (document.referrer || "").substring(0, 500);
            changed = true;
        }
        if (changed) window.sessionStorage.setItem(KEY, JSON.stringify(stored));
    } catch (e) {
        // never block the page over attribution
    }
}

/** Adds hidden inputs for the stored values to a form that does not already have a field with that name. */
export function addAttributionFields(form: HTMLFormElement | null): void {
    if (!form) return;
    try {
        const stored = readStored();
        for (const name of UTM_NAMES.concat(["first_referrer"])) {
            const value = stored[name];
            if (!value || form.querySelector('[name="' + name + '"]')) continue;
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;
            form.appendChild(input);
        }
    } catch (e) {
        // ignore
    }
}
